import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IProgressDescriptionProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    withProgressContext
} from "../../context";
import Text from "../../../text";

const ProgressDescriptionContent: FC<ProgressPartContentProps<IProgressDescriptionProps>> = ({
    customTheme: customThemeProp,
    icon: IconComponentProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const content = children ?? context.description;

    if(!content && !IconComponentProp) {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            IconComponentProp ?
                <IconComponentProp
                    customColor={context.currentColors.descriptionColor}
                    size={context.currentSize.iconSize}
                    color="mid"
                />
            :
                null
        }
        {
            content ?
                <Text
                    customColor={context.currentColors.descriptionColor}
                    customTheme={customTheme}
                    variant="bodySmallSize"
                    style={stylesheet.text}
                >
                    {content}
                </Text>
            :
                null
        }
    </View>;
};
export default withProgressContext("Description", ProgressDescriptionContent);
